import React, { JSX } from 'react';

interface Props {
  icon: string;
  title: string;
  text: string;
}

export const Tip: React.FC<Props> = ({ icon, title, text }): JSX.Element => (
  <div className="flex items-start gap-3 rounded-xl border border-gray-100 p-3">
    <div className="mt-0.5 text-xl leading-none">{icon}</div>
    <div>
      <p className="text-sm font-medium">{title}</p>
      <p className="text-xs text-gray-600">{text}</p>
    </div>
  </div>
);
